<style>
</style>
<template>
    <v-container fluid id="my--cards">
        <v-row class="background: secondary">
            <v-container fluid style="max-width: 960px;">
                <v-col class="caption" cols="12">{{ $t('Filtr pro zobrazení') }}</v-col>
                <v-chip-group v-model="filter" column multiple class="mt-n2 mb-2">
                    <v-chip filter value="active" color="primary">{{ $t('Včetně neaktivních') }}</v-chip>
                    <v-chip filter value="associated" color="primary">{{ $t('Včetně přidružených') }}</v-chip>
                </v-chip-group>
            </v-container>
        </v-row>
        <v-container fluid class="px-0 py-0" style="max-width: 960px;">
            <v-data-table
                    :loading="loading"
                    :headers="headers"
                    :items="items"
                    class="mt-4 mb-4"
                    item-key="cardId"
                    :sort-by="sortBy"
            >
                <template v-slot:item.mainRate="{ item }">{{ item.mainRate ? item.mainRate.name : '' }}</template>
                <template v-slot:item.validTo="{ item }">{{ item.validTo | moment('D.M.Y') }}</template>
                <template v-slot:item.customerDisplayedCredit="{ item }">{{
                    item.customerDisplayedCredit | currency
                    }}
                </template>
                <template v-slot:item.states="{ item }">
                    <my-card-states :card="item"></my-card-states>
                </template>
                <template v-slot:item.options="{ item }">
                    <my-card-options :card="item"></my-card-options>
                </template>
            </v-data-table>
        </v-container>
        <!--    <v-row class="background: grey lighten-1">-->
        <!--      <v-container fluid class="px-0 py-0" style="max-width: 960px;">-->
        <!--        <v-alert type="info" color="grey lighten-1">{{ $t('Zde najdete přehled svých karet') }}</v-alert>-->
        <!--      </v-container>-->
        <!--    </v-row>-->
    </v-container>
</template>
<script>
import DisplayGroupMixin from '@/mixins/display-group-mixin'
import BasketMixin from '@/mixins/basket-mixin.js'
import MyCardOptions from '@/components/my-card-options.vue'
import MyCardStates from '@/components/my-card-states.vue'

export default {
    props: {
        cards: {
            type: Array,
            default() {
                return []
            }
        }
    },
    mixins: [DisplayGroupMixin, BasketMixin],
    components: {
        'my-card-options': MyCardOptions,
        'my-card-states': MyCardStates
    },
    data() {
        return {
            search: null,
            filter: [],
            sortBy: ['displayedCardNo', 'mainRate'],
            headers: [{
                text: 'Název',
                value: 'displayedCardNo',
                align: 'left',
                sortable: true
            }, {
                text: 'Sazba',
                value: 'mainRate',
                align: 'center'
            }, {
                text: 'Platnost',
                value: 'validTo',
                align: 'right',
                sortable: true
            }, {
                text: 'Kredit',
                value: 'customerDisplayedCredit',
                align: 'right'
            }, {
                text: 'Stav',
                value: 'states',
                align: 'center'
            }, {
                text: 'Možnosti',
                value: 'options',
                align: 'center'
            }]
        }
    },
    computed: {
        loading() {
            return this.cards === null
        },
        items() {
            return this.cards !== null ? this.cards.filter(item => this.customFilter(item)) : []
        }
    },
    methods: {
        customFilter(item) {
            return this.isActive(item) && this.isCreditedCard(item)
        },
        isActive(item) {
            return this.filter.includes('active') || (item.isActive && item.isValid && !item.blocked)
        },
        isCreditedCard(item) {
            return this.filter.includes('associated') || item.creditCardId === null
        }
    }
}
</script>
